define('views/modules/calendar/calendar/calendar-component/calendar-component',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/events/calendar-events',
    'services/events/template-events',
    'services/user',
    // models & collections
    'collections/calendar/days',
    'collections/calendar/items',
    'models/template/template',
    // views
    'views/modules/calendar/calendar/calendar-component/calendar-week',
    'views/modules/calendar/calendar/calendar-component/item/item-duplicate-modal',
    'views/modules/calendar/calendar/calendar-component/item/item-move-modal',
    'views/modules/calendar/calendar/calendar-component/modal/calendar-session-print-modal',
    // templates
    'text!templates/modules/calendar/calendar/calendar-component/calendar-component.html',
    'text!templates/modules/calendar/calendar/calendar-component/calendar-week-header.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    CalendarEvents,
    TemplateEvents,
    User,
    // models & collections
    CCalendarDays,
    CCalendarItems,
    MTemplate,
    // views
    VCalendarWeek,
    VCalendarItemDuplicateModal,
    VCalendarItemMoveModal,
    VCalendarSessionPrintModal,
    // templates
    TCalendarComponent,
    TCalendarWeekHeader
) {

    var OPTIONS = ['profile', 'group', 'dates', 'url', 'role'];

    var VCalendarComponent = Backbone.Epoxy.View.extend({
        template: TCalendarComponent,
        daysCollection: CCalendarDays,
        itemsCollection: CCalendarItems,
        weekView: VCalendarWeek,

        regions: {
            table: ".calendar-table",
            head: ".calendar-table thead",
            body: ".calendar-table tbody",
        },

        initialize: function(options) {
            this.options = options || {};
            var listDisplayOptions = this.listDisplayOptions = this.options.listDisplayOptions ||
                new Backbone.Model({
                    listDisplay: false,
                    manualListDisplay: false,
                    forcedListDisplay: false,
                });

            _.extend(this, _.pick(options, OPTIONS), {
                bindingSources: { options: listDisplayOptions },
                view: {},
                collection: new this.daysCollection(),
                items: new this.itemsCollection()
            });
            if (!this.url) this.url = {};

            this.listenTo(this.items, {
                "add": this.onNewItem,
                'update': this.onItemsUpdate,
                "item:duplicate": this.onDuplicateItem,
                "item:print": this.onPrintItem,
                "item:move:modal": this.onMoveItem
            });

            this.listenTo(this.items, {
                'change:week': this.onItemWeekChange,
                'destroy': this.onItemWeekChange,
            });

            this.listenTo(listDisplayOptions, {
                "change:manualListDisplay": this.toggleListDisplay,
                "change:forcedListDisplay": this.onForcedListDisplayChange,
                "change:listDisplay": this.onCalendarDisplayChange,
            });

            this.listenTo(this.collection, { "change:date": this.onItemDateChange })
                .listenTo(this.profile, { "sync": this.onProfileSync })
                .listenTo(User, { "change:units": this.onUserSync });


        },

        render: function() {
            this.initListener();

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.applyBindings();

            this.generateZones()
                .renderCalendarHead()
                .loadCalendar()
                .onResize();

            return this;
        },

        initListener: function() {
            this.stopListeningTo(CalendarEvents);
            this.listenTo(CalendarEvents, {
                'item:update': this.onItemUpdate,
                'session:update': this.onSessionUpdate,
                'template:assign': this.onTemplateAssign,
                'session:destroy': this.onSessionDestroy
            });
        },

        loadCalendar: function() {
            this.fetchDays();
            return this;
        },

        renderCalendar: function() {
            this.zone.$body.empty();
            // Remove existing weeks
            this.removeChildViews({ defer: true });

            this.items.reset(this.collection.getAllItems(), { silent: true });

            this.addAllWeeks();

            CalendarEvents.calendarRenderComplete();

            return this;
        },

        addAllWeeks: function() {
            var totalWeeks = Math.ceil(this.collection.length / 7),
                container = document.createDocumentFragment();

            for (var i = 0; i < totalWeeks; i++) {

                var start = i * 7;
                var end = start + 7;

                var days = this.collection.slice(start, end);

                container.appendChild(this.addWeek(days, 0, false));
            }

            this.zone.$body.append(container);
        },

        addWeek: function(days, delay, render) {
            var daysCollection = new this.daysCollection(days),
                view = new this.weekView(_.extend({
                    collection: daysCollection,
                    url: Mustache.render(this.url.root || "", { userId: 'me' }),
                    role: this.role,
                }, _.result(this, 'weekOptions', false)));

            this.childViews.push(view);
            view.render();

            if (delay > 0) {
                view.$el.addClass("transparent");

                _.delay(function() {
                    view.$el.removeClass("transparent");
                }, delay);
            }

            if (render !== false) {
                this.zone.$body.append(view.el);
            }

            return view.el;
        },

        renderCalendarHead: function() {
            this.zone.$head
                .empty()
                .append(Mustache.render(TCalendarWeekHeader, Mustache.getContext()));
            return this;
        },

        scrollToActive: function() {
            var $active = this.zone.$body.find(".day.active");

            if ($active.length > 0) {
                // $active.get(0).scrollIntoView();
                var calendarModulePositionTop = Backbone.$('.calendar-component').position().top,
                    activePositionTop = $active.position().top,
                    activeHeight = $active.height();

                Backbone.$('#page').animate({
                    scrollTop: activePositionTop + calendarModulePositionTop - (Viewport.height() / 2 - activeHeight / 2)
                }, 500);
            }
        },

        fetchDays: function() {
            var count = this.dates.get('to').diff(this.dates.get('from'), 'days') + 1;
            this.collection.fetch({
                context: this,
                date: this.dates.get('from'),
                count: count,
                user: this.profile.id,
                reset: true,
                success: this.renderCalendar
            });
        },
        /////////////////////
        // Calendar events //
        /////////////////////
        onItemUpdate: function(model) {
            this.items.set(model, { remove: false }); // only update
        },

        onSessionUpdate: function(session, origin) {
            var items = this.items;
            items.updateSession(session);
            // adds the new items
            if (session.hasReceivedChanges()) {
                items.add(session.getReceivedChanges().added);
            }
        },

        onSessionDestroy: function(sessionId) {
            var items = this.items,
                toRemove = items.where({ session: sessionId });

            items.remove(toRemove);
        },

        ////////////
        // events //
        ////////////

        onNewItem: function(model, collecton, options) {
            this.collection.updateItem(model);
        },

        onDuplicateItem: function(model) {
            var view = this.view,
                duplicate = view.duplicate;
            if (!duplicate) {
                duplicate = view.duplicate = new VCalendarItemDuplicateModal();
            }

            model.set("user", this.options.profile.get("_id"));
            duplicate.setModel(model).render();
        },

        onPrintItem: function(model) {
            var view = this.view,
                modal = view.sessionPrint || (view.sessionPrint = new VCalendarSessionPrintModal());

            if (model.get('session').startsWith('@')) {
                var session = this.model.get('sessions').findWhere({ _id: model.get('session') });
                modal.setModel(model).setSession(session);
                return;
            }
            modal.setModel(model).fetchRelatedSession();
        },

        onMoveItem: function(model) {
            var move = this.view.move || new VCalendarItemMoveModal();
            move.setModel(model).render();
        },

        onItemDateChange: function(model, value) {
            this.collection.updateDate(model);
        },

        onItemsUpdate: function(collection, options) {
            var find = _.find,
                profile = this.profile,
                compare = function(model) { return model.getType() === 'biometric'; },
                added = find(options.changes.added, compare),
                removed = find(options.changes.removed, compare),
                merged = find(options.changes.merged, compare);

            if ((added || removed || merged) && profile) {
                profile.fetch();
            }
        },

        onProfileSync: function(model, response, options) {
            if (this.collection.user !== model.id) {
                this.loadCalendar();
            }
        },

        onUserSync: function(model) {
            this.renderCalendar();
        },

        onTemplateAssign: function() {
            this.render();
        },

        //////////////////
        // list display //
        //////////////////
        toggleListDisplay: function() {
            var options = this.listDisplayOptions;
            options.set('listDisplay', Boolean(
                options.get('forcedListDisplay') ||
                options.get('manualListDisplay')
            ));
        },

        onCalendarDisplayChange: function(model, value, options) {
            if (!this.zone) return;
            _.defer(this.scrollToActive.bind(this));
        },

        onForcedListDisplayChange: function(model, value, options) {
            this.toggleListDisplay();
        },

        ///////////////////
        // common events //
        ///////////////////

        onDisable: function() {
            this.stopListeningTo(CalendarEvents);
        },

        onResize: function(e) {
            if (this.zone) {
                this.listDisplayOptions.set('forcedListDisplay', this.$el.width() < 840);
            }
        },

        onItemWeekChange: function(model) {
            if (model.get('type') === "animated") {
                CalendarEvents.onItemWeekChange(model.get('session'));
            }
        },

        onAddDayItem: _.noop,

    });

    return VCalendarComponent;
});

